<template>
  <div class="history-chat-list">
    <div
      class="question-answer"
      v-for="(item, index) in chatListData"
      :key="index"
    >
      <div class="question-item" >
        <p>{{ item.question }}</p>

        <el-tooltip
          v-if="item.type === 1"
          effect="dark"
          content="专家查询"
          placement="top"
          popper-class="hover-popper"
        >
          <scholarIcon width="30px" height="30px" :fill="'#666'" />
        </el-tooltip>
        <el-tooltip
          v-if="item.type === 2"
          effect="dark"
          content="技术问答"
          placement="top"
          popper-class="hover-popper"
        >
          <questionIcon
            v-if="item.type === 2"
            width="22"
            height="22"
            :fill="'#666'"
          />
        </el-tooltip>
        <el-tooltip
          v-if="item.type === 3"
          effect="dark"
          content="文献调研"
          placement="top"
          popper-class="hover-popper"
        >
          <literatureIcon
            v-if="item.type === 3"
            width="14"
            height="14"
            :fill="'#666'"
          />
        </el-tooltip>
      </div>
      <div class="answer-item">
        <div class="avatar">
          <img :src="require('@/assets/images/common/ai-answer.png')" alt="" />
        </div>
        <div class="answer-con">
          <!-- 显示回答的问题，如果文献调研下载完 -->
          <div
            class="answer-text download-literature"
            v-if="
              item.type === 3 && item.answer === '文献综述已生成完毕，点击下载'
            "
          >
            <span @click="downloadLiterature(item.task_id)">{{
              item.answer
            }}</span>
          </div>
          <div class="answer-text" v-else>
            <div v-if="item.type !== 2">
              <toggle-component v-if="item.thinking" :default-visible="true">
                <div class="thinking-con" v-html="sanitizeHTML(item.thinking)"></div>
              </toggle-component>

              <div style="white-space: normal"
                   v-html="sanitizeHTML(item.answer)"
              ></div>
            </div>
            <p v-else>
              {{ item.isTranslated ? item.translatedValue : item.answer }}
            </p>
          </div>
        </div>
      </div>
      <!--  操作按钮  -->
      <div
        class="flex operate-btn"
        style="height: 30px"
        v-if="
          (item.scholar_card && item.scholar_card.length) ||
          (item.type === 2 && isNotEmptyObject(item.refs))
        "
      >
        <el-tooltip
          effect="dark"
          content="复制"
          placement="top"
          popper-class="hover-popper"
        >
          <img
            style="width: 24px; height: 24px; margin-top: -2px; cursor: pointer"
            :src="require('@/assets/images/common/copy-icon.png')"
            alt="copy"
            @click="handleCopyAnswer(item)"
          />
        </el-tooltip>

        <!-- 翻译 -->
<!--        <div class="translate flex" v-if="item.type === 2">
          <div style="font-size: 14px; color: #666" v-if="item.isTranslating">
            翻译中....
          </div>
          <div v-else>
            <el-tooltip
              effect="dark"
              content="翻译"
              placement="top"
              popper-class="hover-popper"
              v-if="!item.isTranslated"
            >
              <translateIcon
                @click="toggleTranslate(index)"
                style="cursor: pointer"
                width="20px"
                height="20px"
                fill="rgb(0, 91, 172)"
              />
            </el-tooltip>
            <div
              v-else
              style="cursor: pointer; color: rgb(0, 91, 172); font-size: 14px"
              @click="toggleTranslate(index)"
            >
              查看原文
            </div>
          </div>
        </div>-->

        <div style="flex: 1; display: flex; justify-content: flex-end">
          <span
            class="look-infor"
            v-if="item.scholar_card && item.scholar_card.length"
            @click="viewCardData('scholar', index)"
            >查看来源专家</span
          >
          <span
            class="look-infor"
            v-if="item.type === 2 && isNotEmptyObject(item.refs)"
            @click="viewCardData('paper', index)"
            >查看参考文献</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MarkdownIt from 'markdown-it';
import DOMPurify from 'dompurify'; // HTML 消毒库
import translateIcon from '@/assets/images/home/translate-icon.svg';
import scholarIcon from '@/assets/images/home/btn1.svg';
import literatureIcon from '@/assets/images/home/btn3.svg';
import questionIcon from '@/assets/images/home/btn2.svg';
import { downloadLiteratureApi, translateApi } from '@/api/chat';
import { isNotEmptyObject, stripHtml } from '@/utils/utilsFn';
import ToggleComponent from '@/components/ToggleComponent.vue';

export default {
  name: 'historyChatListComp',
  components: {
    questionIcon,
    literatureIcon,
    scholarIcon,
    translateIcon,
    ToggleComponent,
  },
  props: ['chatListData'],
  data() {
    return {
      isNotEmptyObject, // 判断数据不是空对象
    };
  },
  created() {},
  methods: {
    sanitizeHTML(html) {
      if (!html) return '';

      // 创建 Markdown 实例（放外面可复用）
      const md = new MarkdownIt({
        html: true, // 允许解析 HTML 标签
        linkify: true, // 自动识别链接
        breaks: false // 换行自动转 <br>
      });

      // 把 Markdown 转成 HTML
      const renderedHTML = md.render(html);

      // 使用 DOMPurify 清理 XSS
      return DOMPurify.sanitize(renderedHTML);
    },


    // 下载已生成的文献
    downloadLiterature(id) {
      downloadLiteratureApi({ user: this.userId, id })
        .then((res) => {
          // 校验数据有效性
          if (!(res.data instanceof Blob) || res.data.size === 0) {
            throw new Error('无效的二进制数据');
          }

          // 解析文件名
          let attrs = res.headers['content-disposition'].split(';');
          let fileName = '';
          // 不用管fileName在第几个位置，只要=前面是fileName,就取=后面的值
          for (let i = 0, l = attrs.length; i < l; i++) {
            let temp = attrs[i].split('=');
            if (temp.length > 1 && temp[0].trim() === 'filename') {
              fileName = temp[1];
              break;
            }
          }
          fileName = fileName.replace(new RegExp('"', 'g'), '');

          // 创建 Blob 并下载
          const blob = new Blob([res.data], {
            type: 'application/octet-stream',
          });

          // 创建URL
          const link = document.createElement('a');
          const blobUrl = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.href = blobUrl;
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(blobUrl);
          document.body.removeChild(link);
        })
        .catch((error) => {
          console.error('下载失败:', error);
          this.$message.error('文件下载失败，请检查任务状态');
        });
    },

    /**
     * 翻译
     * @param index 下标index
     * @returns {Promise<boolean>}
     */
    async toggleTranslate(index) {
      const item = this.chatListData[index];

      // 已翻译：直接切换状态
      if (item.translatedValue) {
        item.isTranslated = !item.isTranslated;
        return false;
      }

      // 避免重复调用接口
      if (item.isTranslating) return false;

      try {
        // 开始翻译
        item.isTranslating = true;
        const res = await translateApi({
          text: item.answer,
          target_language: 'chinese',
        });
        this.$message.success('翻译完成');

        // 更新缓存和状态
        item.translatedValue = res.response;
        item.isTranslated = true;
      } catch (error) {
        console.error('翻译失败', error);
      } finally {
        item.isTranslating = false;
      }
    },

    // 点击历史回答卡片列表
    viewCardData(type, index) {
      this.$emit('viewCardData', { type, index });
    },

    // 一键复制答案
    handleCopyAnswer(item) {
      // 去除所有HTML标签
      let stripHtmlText;
      if (item.isTranslated) {
        stripHtmlText = stripHtml(item.translatedValue);
      } else {
        stripHtmlText = stripHtml(item.answer);
      }
      // 创建临时textarea元素
      const textarea = document.createElement('textarea');
      textarea.value = stripHtmlText;
      textarea.style.position = 'fixed'; // 防止页面滚动
      document.body.appendChild(textarea);
      textarea.select();

      try {
        // 执行复制命令
        const successful = document.execCommand('copy');
        if (successful) {
          this.$message.success('复制成功');
        }
      } catch (err) {
        console.error('复制失败:', err);
      }

      // 移除临时元素
      document.body.removeChild(textarea);
    },
  },
  watch: {},
};
</script>

<style scoped lang="less">
.history-chat-list {
  // background-color: #F6F8FD;
  .question-answer {
    //width: 800px;
    margin: 15px auto 10px;
    padding-right: 40px;
    position: relative;

    &:not(:last-child) {
      border-bottom: 1px dashed rgba(0, 0, 0, 0.1);
    }
  }

  .question-item {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
    margin-right: -20px;

    > p {
      max-width: 500px;
      padding: 12px 15px;
      background: #eff6ff;
      border-radius: 8px;
      line-height: 1.5;
      margin-right: 10px;
    }
  }

  .answer-item {
    display: flex;
    white-space: pre-wrap;

    .avatar {
      width: 30px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      flex-shrink: 0;
      margin-top: 4px;

      img {
        height: 22px;
      }
    }

    .answer-con {
      flex: 1;
      text-align: left;
      padding: 5px 20px 10px;

      .answer-text {
        //display: flex;
        flex-wrap: wrap;
        width: 100%;
        text-align: justify;
        //margin-bottom: 10px;

        .deep-thinking-tips {
          height: 40px;
          line-height: 40px;
          font-size: 15px;
          color: #999;
        }
      }

      .thinking-con {
        background-color: rgba(243, 244, 246, 0.8);
        padding: 15px 15px 0;
        border-radius: 8px;
        width: 95.5%;
        //opacity: 0.7;
        font-size: 14px;
        color: #888;
        margin-bottom: 10px;
        line-height: 1.8;
      }

      .download-literature {
        span {
          cursor: pointer;
          color: rgb(0, 91, 172);

          &:hover {
            text-decoration: underline;
          }
        }
      }

      .loading-css {
        width: 30px;
      }

      .refs {
        margin-top: 20px;
        font-size: 14px;
        border-top: 1px solid #dbdbdb;
        padding-top: 10px;
        line-height: 19px;

        p {
          color: #808080;
          margin-top: 5px;

          span {
            cursor: default;
          }
          a {
            color: #808080;
            cursor: default;
            //padding-left: 10px;
            //font-weight: bold;
            &:hover {
              //color: rgb(0, 91, 172);
            }
          }

          b {
            padding-left: 10px;
          }
        }
      }
    }
  }

  .translate {
    height: 20px;
    margin-left: 20px;
  }

  .copy-answer {
    margin-left: 30px;
    font-size: 14px;
    color: rgb(0, 91, 172);
    cursor: pointer;
  }

  .look-infor {
    height: 25px;
    line-height: 25px;
    cursor: pointer;
    color: #999;
    border: 1px solid #999;
    font-size: 13px;
    padding: 0 10px;
    border-radius: 6px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
    margin-right: 10px;

    &:hover {
      color: #333333;
      border: 1px solid #333333;
    }
  }
}

.operate-btn {
  margin-bottom: 10px;
  margin-left: 50px;
}
</style>
